import { PersonalUserInfoContainer } from 'modules/Users';

const PersonalUserInfo = () => {
  return <PersonalUserInfoContainer />;
};

export default PersonalUserInfo;
